"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _PinnedReplyLabel = _interopRequireDefault(require("@insided/deprecated-preact-components/pinned-reply/PinnedReplyLabel"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _UserAvatar = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserAvatar"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _common = require("@insided/shared/utils/common");

var _classnames = _interopRequireDefault(require("classnames"));

var _dateFormatDestination = _interopRequireDefault(require("@insided/deprecated-preact-components/utils/dateFormatDestination"));

var _Content = _interopRequireDefault(require("@insided/deprecated-preact-components/common/Content"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-enabled import/no-internal-modules */
var PinnedReplyInContent = function PinnedReplyInContent(_ref) {
  var pinnedReply = _ref.pinnedReply;
  return (0, _preact.h)("div", {
    className: "post__content pinned-reply__label--firstpost"
  }, (0, _preact.h)(_PinnedReplyLabel.default, {
    phrase: (0, _preact.h)(_phrase.default, {
      p: "reply.pinned",
      m: "Forum"
    })
  }), (0, _preact.h)("div", {
    className: "post--pinned pinned-reply-field"
  }, (0, _preact.h)("p", {
    className: "pinned-reply-field__header"
  }, (0, _preact.h)("div", {
    className: "pinned-reply-field__user-info"
  }, (0, _preact.h)(_UserAvatar.default, {
    user: _objectSpread(_objectSpread({}, pinnedReply.author), {
      name: pinnedReply.author.username
    }),
    extraClass: "avatar avatar--responsive avatar--pinned-reply",
    showRank: true
  }), String(pinnedReply.author.id) === '' ? (0, _preact.h)("span", {
    className: "pinned-reply__username"
  }, " ", pinnedReply.author.username, " ") : (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)("/members/user-".concat(pinnedReply.author.id))
  }, pinnedReply.author.username)), (0, _preact.h)("span", {
    className: "text--meta"
  }, (0, _preact.h)(_Tooltip.default, {
    withArrow: true,
    trigger: (0, _preact.h)("time", null, " ", _common.common.relativeDate(pinnedReply.repliedAt), " "),
    tooltipMessage: (0, _preact.h)("div", {
      className: (0, _classnames.default)('tooltip__content', 'tooltip__content--publish-date', 'js-tooltip-content', 'position--bottom')
    }, (0, _dateFormatDestination.default)(new Date(pinnedReply.repliedAt)))
  }))), (0, _preact.h)(_Content.default, {
    content: pinnedReply.content,
    className: "pinned-reply__content"
  })));
};

var _default = PinnedReplyInContent;
exports.default = _default;